import {
  generateURNByKind,
  transformUrnToWitboostId,
} from '@agilelab/plugin-wb-builder-common';
import { asEntity } from '../../types';
import { AdaptedEntity, GenericEntityType, KindEnum } from './types';
import {
  compactCompoundEntityRef,
  expandEntityRef,
} from '@agilelab/plugin-wb-platform-common';
import { parseEntityRef, Entity } from '@mainstage/catalog-model';

export const calculatedRef = (castedEntity: Entity): string => {
  return compactCompoundEntityRef({
    kind: castedEntity.kind,
    name: castedEntity.metadata.name,
    namespace: 'default',
  });
};

export const catalogEntityAdapter = (
  entity: GenericEntityType,
  parsedLabel?: string,
  refExpanded?: boolean,
): AdaptedEntity => {
  const castedEntity = asEntity(entity);
  if (castedEntity) {
    return {
      name: entity.metadata.name,
      kind: entity.__metadata?.kind ?? entity.kind,
      label:
        parsedLabel ||
        entity.spec?.mesh?.displayName ||
        entity.metadata?.title ||
        entity.metadata?.name,
      urn: generateURNByKind(entity.metadata.name, entity.kind, true),
      ref: refExpanded
        ? expandEntityRef(calculatedRef(castedEntity))
        : calculatedRef(castedEntity),
    };
  }

  if (!entity?.id) {
    throw new Error(
      `Entity id is missing. Cannot transform to AdaptedEntity: ${JSON.stringify(
        entity,
      )}`,
    );
  }
  const unknownRef = transformUrnToWitboostId(entity?.id);
  if (!unknownRef) {
    throw new Error(
      `Invalid URN. Check your entity id: ${JSON.stringify(entity)}`,
    );
  }
  const unknownCompoundRef = parseEntityRef(unknownRef);

  // fallback for when the entity does not match any kind, mainly for subcomponents since they do not have metadata
  return {
    name: unknownCompoundRef.name,
    kind: entity.__metadata?.kind ?? KindEnum.consumable,
    label: entity.name,
    urn: entity.id,
    ref: entity.id,
  };
};
